/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { fetchDashboardJobs } from '../../../../_redux/features/dashboard/dashboardSlice';
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button } from 'antd';

const JobsDashboard: React.FC = () => {
    const intl = useIntl()
    const dispatch = useDispatch<any>()
    const navigate = useNavigate()
    const { dashboardJobs, isLoading } = useSelector((state: any) => state.dashboard)
    useEffect(() => { dispatch(fetchDashboardJobs()) }, [])
    const renderedItems = dashboardJobs.map((item, index) => (
        <tr key={index}>
            <td>
                <div className='symbol symbol-45px me-2'>
                    <span className='symbol-label'>
                        <img src={`${item.mainPic}`} className='h-50 align-self-center' alt='' />
                    </span>
                </div>
            </td>
            <td>
                <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                    {item.title}
                </a>
                <span className='text-muted fw-semibold d-block'>{item.company}</span>
            </td>
            <td className='text-end text-muted fw-semibold'> 
                {intl.formatDate(item.adStartDate, {
                    year: 'numeric',
                    month: 'long', // or 'short' or 'numeric'
                    day: '2-digit', // or 'numeric'
                })}</td>
            <td className='text-end'>
                <a href={`/graduation-panel/jobs/${item.id}/detail`} className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'>
                    <KTIcon iconName='arrow-right' className='fs-2' />
                </a>
            </td>
        </tr >
    ));
    return (
        <div className={`card card-xxl-stretch mb-5 mb-xxl-8`}>
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>{intl.formatMessage({ id: 'JOBADVERT.LATESTJOBS' })}</span>
                </h3>
                <Button onClick={() => navigate("/graduation-panel/jobs")}>{intl.formatMessage({ id: 'JOBADVERT.ALLJOBS' })}</Button>
            </div>
            <div className='card-body py-3'>
                <div>
                    <div>
                        <div>
                            <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                                <thead>
                                    <tr className='border-0'>
                                        <th className='p-0 w-50px'></th>
                                        <th className='p-0 min-w-150px'></th>
                                        <th className='p-0 min-w-140px'></th>
                                        <th className='p-0 min-w-110px'></th>
                                        <th className='p-0 min-w-50px'></th>
                                    </tr>
                                </thead>
                                <tbody>{renderedItems}</tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export { JobsDashboard }
